module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zen-change-action"
  }, [(_vm.isDone) ? _c('span', {
    staticClass: "zen-change-action__done"
  }, [_c('span', {
    staticClass: "icon-checkmark"
  }), _vm._v("\n    " + _vm._s(_vm.doneLabel) + "\n  ")]) : (_vm.isLoading) ? _c('button', {
    staticClass: "zen-bttn",
    attrs: {
      "disabled": ""
    }
  }, [_c('span', {
    staticClass: "zen-spinner"
  })]) : (_vm.isConfirming) ? _c('div', {
    staticClass: "zen-change-action__confirm"
  }, [_c('span', {
    staticClass: "zen-change-action__confirm-text"
  }, [_vm._v(_vm._s(_vm.$t('vue2.zen_import.confirm')))]), _vm._v(" "), _c('button', {
    staticClass: "zen-bttn zen-bttn--danger",
    on: {
      "click": function($event) {
        return _vm.$emit('confirm')
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.zen_import.yes')) + "\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "zen-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('setState', 'idle')
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.zen_import.cancel')) + "\n    ")])]) : _c('button', {
    staticClass: "zen-bttn",
    class: {
      'zen-bttn--danger-outline': _vm.actionType === 'delete'
    },
    on: {
      "click": function($event) {
        return _vm.$emit('setState', 'confirming')
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.actionLabel) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a35d590a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZenImport/ZenChangeAction.vue
// module id = 2075
// module chunks = 1